import { defineComponent as _defineComponent } from 'vue';
import Button from "@/components/ui/button/Button.vue";
import Panel from "@/components/ui/panel/Panel.vue";
import Select from "@/components/ui/select/Select.vue";
import { computed } from "vue";
// Component props
export default /*@__PURE__*/ _defineComponent({
    __name: 'DatasetFilter',
    props: {
        dataset: { type: null, required: true },
        fields: { type: Object, required: true },
        filterOptions: { type: Object, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const resolvedFilterOptions = computed(() => { var _a; return (_a = props.filterOptions) !== null && _a !== void 0 ? _a : props.dataset.filterOptions.value; });
        // Get available filter columns from the dataset
        const availableFilterColumns = computed(() => {
            // Show all configured filter columns, even if they don't have options yet
            return Object.keys(props.dataset.filters)
                .map((key) => props.fields.get(key))
                .filter(Boolean); // Remove any undefined fields
        });
        // Computed to check if there are any active dataset filters
        const hasActiveFilters = computed(() => {
            return props.dataset.hasActiveFilters.value;
        });
        // Generic filter change handler - directly use dataset setFilter
        const handleFilterChange = (filterKey, value) => props.dataset.setFilter(filterKey, value);
        // Clear all dataset filters only
        const clearAllFilters = () => props.dataset.clearFilters();
        const __returned__ = { props, resolvedFilterOptions, availableFilterColumns, hasActiveFilters, handleFilterChange, clearAllFilters, Button, Panel, Select };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
